/* BD callback v1, 23.09.2026: progressive links, a single movable form and accessible dialog. */
(function () {
  'use strict';
  if (window.bdCallbackShell) return;
  var dialog, mount, card, home, slot, trigger, observer;
  var shown = new Map();
  var chatObserver, chatDiscovery, watchedChat, positionFrame;
  var contextSequence = 0, baseProduct = null;
  var productContexts = new Map();
  function readProduct(source, expectedHandle) {
    if (!source || source.dataset.productKnown !== 'true') return null;
    var handle = source.dataset.productHandle || '';
    var form = source.querySelector('form[data-bd-callback-contact]');
    var titleField = form && form.elements.namedItem('contact[Produkt]');
    var title = titleField && titleField.value;
    if (!/^[a-z0-9][a-z0-9-]{0,179}$/.test(handle) || (expectedHandle && handle !== expectedHandle) || !title) return null;
    var technology = form.elements.namedItem('contact[Technik]');
    return { known: true, handle: handle, title: title, machine: source.dataset.machineProduct === 'true', technology: technology ? technology.value : 'Noch offen' };
  }
  function productContext(handle) {
    if (productContexts.has(handle)) return Promise.resolve(productContexts.get(handle));
    if (!window.fetch || !window.DOMParser || !/^[a-z0-9][a-z0-9-]{0,179}$/.test(handle || '')) return Promise.reject(new Error('Product unavailable'));
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var url = previewQuery(new URL(root + 'products/' + encodeURIComponent(handle), location.origin));
    url.searchParams.set('view', 'bd-callback');
    return fetch(url.href, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } }).then(function (r) {
      if (!r.ok || new URL(r.url || url.href).origin !== location.origin) throw new Error('Product unavailable');
      return r.text();
    }).then(function (html) {
      // Extract only server-resolved product metadata. Never insert fetched markup,
      // scripts, or a second form into the live document.
      var page = new DOMParser().parseFromString(html, 'text/html');
      var product = readProduct(page.querySelector('[data-bd-callback-card]'), handle);
      if (!product) throw new Error('Product unavailable');
      productContexts.set(handle, product);
      return product;
    });
  }
  function positionBadge() {
    var chat = document.querySelector('.bb-root');
    if (chat && chat !== watchedChat && window.MutationObserver) {
      if (chatObserver) chatObserver.disconnect();
      watchedChat = chat;
      if (chatDiscovery) { chatDiscovery.disconnect(); chatDiscovery = null; }
      chatObserver = new MutationObserver(syncVisibility);
      chatObserver.observe(chat, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }
    // BeamBuddy moves above the shop's sticky controls. Measure its real position
    // instead of assuming that the chat always sits 24px above the viewport edge.
    var bottom = 112;
    if (chat) {
      var rect = chat.getBoundingClientRect();
      if (rect.width && rect.height && rect.top < window.innerHeight && rect.bottom > 0) {
        bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top + 24));
      }
    }
    document.querySelectorAll('.bd-callback-badge').forEach(function (el) {
      el.style.setProperty('--bd-callback-bottom', bottom + 'px');
    });
  }
  function schedulePosition() {
    if (positionFrame) return;
    positionFrame = requestAnimationFrame(function () { positionFrame = null; syncVisibility(); });
  }
  function previewQuery(url) {
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && /^(unpublished|development)$/i.test(theme.role) && /^\d+$/.test(String(theme.id))) url.searchParams.set('preview_theme_id', String(theme.id));
    return url;
  }
  function refreshLabels() {
    if (!window.bdCallbackTime) return;
    var description = window.bdCallbackTime.describe(new Date());
    document.querySelectorAll('[data-bd-callback-label]').forEach(function (el) { el.textContent = description.buttonLabel; });
  }
  function visibleRect(el) {
    if (el.closest('[hidden], [aria-hidden="true"], dialog:not([open])')) return null;
    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return null;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return null;
    return rect;
  }
  function otherCallbackVisible() {
    return Array.from(document.querySelectorAll('a[data-bd-callback-open]:not(.bd-callback-badge)')).some(function (el) {
      var rect = visibleRect(el);
      // A partly clipped header/footer link is not an equivalent usable entry.
      return rect && rect.top >= 0 && rect.bottom <= window.innerHeight && rect.left >= 0 && rect.right <= window.innerWidth;
    });
  }
  function protectedControlsVisible() {
    return Array.from(document.querySelectorAll('form, footer, .bd26-footer, .bd21-hero-actions, .hdt-control-sorting, .bd-finance-options')).some(function (el) { return !!visibleRect(el); });
  }
  function syncVisibility() {
    positionBadge();
    var formVisible = Array.from(shown.values()).some(Boolean);
    document.body.classList.toggle('bd-callback-form-visible', formVisible);
    var obstructed = !!document.querySelector('#bd35-notice.is--open, .bb-root.offen');
    var cmp = document.querySelector('pandectes-cmp');
    try { obstructed = obstructed || !!(cmp && cmp.shadowRoot && cmp.shadowRoot.querySelector('dialog[open]')); } catch (e) {}
    var alternative = otherCallbackVisible();
    var protectControls = protectedControlsVisible();
    // Reuse an already visible callback entry. Otherwise keep a narrow edge tab
    // while forms, sorting controls, hero actions or footer links are in view.
    // The existing scroll/resize RAF handles this without moving any page content.
    document.querySelectorAll('.bd-callback-badge').forEach(function (el) {
      var focused = el === document.activeElement;
      el.hidden = !!(dialog && dialog.open) || obstructed || (alternative && !focused);
      el.classList.toggle('bd-callback-badge--edge', protectControls || alternative);
    });
  }
  function observeForms() {
    if (observer) observer.disconnect();
    shown.clear();
    if (!window.IntersectionObserver) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { shown.set(entry.target, entry.isIntersecting); });
      syncVisibility();
    }, { threshold: 0.01 });
    document.querySelectorAll('#bd21-machine-lead, [data-bd-callback-card], .bd-machine-callback-entry, form[data-bd-local-contact="true"]').forEach(function (el) { observer.observe(el); });
  }
  function closeSheet() { if (dialog && dialog.open) dialog.close(); }
  function inlineSlotUnavailable() {
    if (!slot) return true;
    // A mobile product slot can exist in the DOM while an ancestor hides it.
    // Off-screen but visible inline forms do not need an automatic dialog.
    var node = slot;
    while (node && node.nodeType === 1) {
      if (node.hidden || window.getComputedStyle(node).display === 'none') return true;
      node = node.parentElement;
    }
    var visibility = window.getComputedStyle(slot).visibility;
    return visibility === 'hidden' || visibility === 'collapse';
  }
  function openSheet(link) {
    if (!dialog || !mount || !card || typeof dialog.showModal !== 'function') return false;
    trigger = link;
    if (slot) slot.style.minHeight = Math.ceil(slot.getBoundingClientRect().height) + 'px';
    mount.appendChild(card);
    dialog.showModal();
    document.body.classList.add('bd-callback-open');
    var focus = card.querySelector('[data-bd-callback-confirmed]:not([hidden]), [role="alert"]:not([hidden])') ||
      card.querySelector('input[autocomplete="name"], input:not([type="hidden"])');
    if (focus) focus.focus({ preventScroll: true });
    syncVisibility();
    return true;
  }
  function restoreCard() {
    (slot || home).appendChild(card);
    if (slot) slot.style.minHeight = '';
    document.body.classList.remove('bd-callback-open');
    if (trigger && trigger.isConnected) {
      var menu = trigger.closest('#bd27-offcanvas');
      var target = menu && menu.getAttribute('aria-hidden') === 'true' ? document.querySelector('[data-bd27-menu-open]') : trigger;
      if (target) target.focus({ preventScroll: true });
    }
    syncVisibility();
  }
  function installSlot() {
    slot = document.querySelector('[data-bd-callback-slot]');
    if (!slot && /^\/pages\/(reinigungslaser-preise|reinigungslaser-vergleich|rost-entfernen-laser|entlacken-mit-laser|holz-laser-reinigen|graffiti-entfernen-geraet|laserreinigungsgeraet-kaufen)\/?$/.test(location.pathname)) {
      var heading = document.querySelector('#MainContent h1');
      if (heading && !heading.closest('form')) {
        slot = document.createElement('div');
        slot.className = 'bd-callback-slot--editorial';
        slot.setAttribute('data-bd-callback-slot', '');
        heading.insertAdjacentElement('afterend', slot);
      }
    }
    if (slot && card) {
      slot.replaceChildren(card);
      home.hidden = true;
    }
  }
  function loadProductContext() {
    if (!document.querySelector('[data-bd-callback-page]') || !window.bdCallbackForm || !window.bdCallbackForm.setContext) return;
    var current = document.querySelector('[data-bd-callback-card]');
    if (!current || current.querySelector('[data-bd-callback-confirmed]:not([hidden]), [role="alert"]:not([hidden])')) return;
    var params = new URLSearchParams(location.search);
    var handle = params.get('produkt');
    var topic = window.bdCallbackForm.financeTopic(params.get('anliegen'));
    window.bdCallbackForm.setContext(current, { topic: topic });
    if (!handle || !/^[a-z0-9][a-z0-9-]{0,179}$/.test(handle)) return;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var topicChanged = false;
    current.addEventListener('change', function (event) { if (event.target.name === 'contact[Rückrufthema]') topicChanged = true; });
    productContext(handle).then(function (product) {
      if (!current.isConnected) return;
      var context = { product: product };
      if (!topicChanged) context.topic = topic;
      if (!window.bdCallbackForm.setContext(current, context)) return;
      var back = document.querySelector('[data-bd-callback-back]');
      if (back) { back.href = previewQuery(new URL(root + 'products/' + handle, location.origin)).href; back.textContent = 'Zurück zum Gerät ↗'; }
      observeForms();
    }).catch(function () { /* The usable general callback form remains in place. */ });
  }
  function init() {
    dialog = document.getElementById('bd-callback-dialog');
    mount = document.querySelector('[data-bd-callback-mount]');
    home = document.querySelector('[data-bd-callback-home]');
    card = home && home.querySelector('[data-bd-callback-card]');
    baseProduct = readProduct(card);
    if (baseProduct) productContexts.set(baseProduct.handle, baseProduct);
    if (home && card) installSlot();
    document.querySelectorAll('[data-bd-callback-open]').forEach(function (link) {
      try {
        var url = new URL(link.href, location.href);
        if (url.origin === location.origin) link.href = previewQuery(url).href;
      } catch (e) {}
      if (dialog && typeof dialog.showModal === 'function') { link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', dialog.id); }
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-bd-callback-open]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!dialog || !mount || !card || typeof dialog.showModal !== 'function') return;
      var api = window.bdCallbackForm;
      var handle = link.getAttribute('data-bd-callback-product') || (baseProduct && baseProduct.handle) || '';
      var topic = api && api.financeTopic ? api.financeTopic(link.getAttribute('data-bd-callback-topic')) : '';
      if (!api || !api.setContext) { if (!topic && !handle && openSheet(link)) event.preventDefault(); return; }
      var sequence = ++contextSequence;
      var currentProduct = readProduct(card);
      if (!handle || (currentProduct && currentProduct.handle === handle)) {
        if (api.setContext(card, { product: handle ? currentProduct : baseProduct, topic: topic }) && openSheet(link)) event.preventDefault();
        return;
      }
      event.preventDefault();
      link.setAttribute('aria-busy', 'true');
      productContext(handle).then(function (product) {
        if (sequence !== contextSequence) return;
        if (!api.setContext(card, { product: product, topic: topic }) || !openSheet(link)) location.assign(link.href);
      }).catch(function () { if (sequence === contextSequence) location.assign(link.href); }).finally(function () { link.removeAttribute('aria-busy'); });
    });
    if (dialog) {
      dialog.querySelector('[data-bd-callback-close]').addEventListener('click', closeSheet);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) closeSheet(); });
      dialog.addEventListener('close', restoreCard);
      // Native dialog provides Escape and a keyboard focus trap.
    }
    document.addEventListener('bd:callback-confirmed', function (event) {
      if (!card || event.target !== card || !dialog || dialog.open || card.dataset.bdCallbackResponse !== 'confirmed') return;
      var form = card.querySelector('form[data-bd-callback-contact]');
      var marker = form && form.querySelector('[data-bd-callback-confirmed]:not([hidden])');
      if (!form || !marker || marker.getAttribute('data-bd-callback-confirmed') !== form.id ||
          !event.detail || event.detail.formId !== form.id || !inlineSlotUnavailable()) return;
      // A response can arrive after the customer closes the waiting dialog.
      openSheet(trigger);
    });
    refreshLabels();
    syncVisibility();
    if (!watchedChat && window.MutationObserver) {
      chatDiscovery = new MutationObserver(function () { if (document.querySelector('.bb-root')) syncVisibility(); });
      chatDiscovery.observe(document.body, { childList: true, subtree: true });
    }
    observeForms();
    loadProductContext();
    setInterval(function () { refreshLabels(); syncVisibility(); }, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { refreshLabels(); syncVisibility(); } });
    window.addEventListener('pageshow', function () { refreshLabels(); syncVisibility(); });
    window.addEventListener('resize', schedulePosition, { passive: true });
    window.addEventListener('scroll', schedulePosition, { passive: true });
    document.addEventListener('focusout', schedulePosition);
    // Only active response targets count; hidden AJAX targets are normal form markup.
    // Reach confirmed native returns even when mobile CSS hides the existing slot.
    var confirmed = card && card.dataset.bdCallbackResponse === 'confirmed' && card.querySelector('[data-bd-callback-confirmed]:not([hidden])');
    var failed = card && card.querySelector('[role="alert"]:not([hidden])');
    if (card && (confirmed || failed) && inlineSlotUnavailable()) openSheet(null);
  }
  window.bdCallbackShell = { refreshLabels: refreshLabels };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
